var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-overlay',{attrs:{"value":_vm.overlay}},[_c('p',[_vm._v("Logging you in securely...")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }